import React, { Dispatch, SetStateAction } from 'react';
import UploadLogo from '../../../common/UploadLogo';
import {
    CommercialError,
    CommercialPayload
} from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import ExporterDetails from '../../CommercialFomComponents/ExporterDetails';
import ConsigneeDetails from '../../CommercialFomComponents/ConsigneeDetails';

const StepOne = ({
    updateField,
    payload,
    corporatePartners,
    errors,
    loadingCorporatepartners,
    setShowAddPartner
}: {
    updateField: (name: string, value: unknown) => void;
    payload: CommercialPayload;
    corporatePartners: CorporatePartner[];
    errors: CommercialError;
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        <div className='w-full flex flex-col gap-1'>
            <UploadLogo {...{ payload, updateField }} />

            <ExporterDetails
                {...{
                    payload,
                    updateField,
                    errors,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner
                }}
            />

            <ConsigneeDetails
                {...{
                    payload,
                    updateField,
                    errors,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner
                }}
            />
        </div>
    );
};

export default StepOne;
